import { render } from "./AppButtonSubmit.vue?vue&type=template&id=81cefd06&scoped=true"
import script from "./AppButtonSubmit.vue?vue&type=script&lang=js"
export * from "./AppButtonSubmit.vue?vue&type=script&lang=js"

import "./AppButtonSubmit.vue?vue&type=style&index=0&id=81cefd06&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cefd06"]])

export default __exports__